export const capitalizeOnlyFirstLetter = (t: string) => {
  return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
}

/**
 * Determine if the current environment is testing/development or if it's a production env.
 *
 * It's considered a production env if the API graphql resource is equal to the API graphql resource used in the production or equal to the
 * API graphql resource used in integration or beta environment.
 * The integration and beta env are considered as production, since they are environments that should mimic the production
 * env as close as possible.
 *
 * The API graphql resource is being checked because some changes might be wanted in the testing environment
 */
export const isTestingEnvironment = () => {
  // will check if the api is the production one or the one used in beta or integration env
  const productionEnvironments = new RegExp('https:\\/\\/api\\.(|beta.|integration.|int.)foodi\\.fr\\/graphql');
  return !productionEnvironments.test(window.config.API_GRAPHQL_ENDPOINT);
}